import { UserRole } from '@/api/types/organization';

export interface UserRoleItem {
  name: string;
  value: UserRole;
  description: string;
}

export const userRoleItems: UserRoleItem[] = [
  {
    name: 'Org Admin',
    value: 'org_super_admin' as const,
    description: 'Has full administrative access to the entire organization.',
  },
  {
    name: 'Org Member',
    value: 'org_member' as const,
    description: 'Standard organization member.',
  },
];

export const userRoleValues = ['org_super_admin', 'org_member'] satisfies [UserRole, ...UserRole[]];
export const userRoleFilterValues = ['all', ...userRoleValues] as const;

export function getUserRoleName(role: UserRole): string {
  return userRoleItems.find((item) => item.value === role)?.name || role;
}
